export const fontSize = {
  h1: 72,
  h2: 56,
  h3: 40,
  h4: 32,
  h5: 24,
  h6: 20,
  subHead: 24,
  description: 20,
  body: 16
};

export const fontSizeMob = {
  h1: 40,
  h2: 24,
  h3: 20,
  h4: 16,
  h5: 16,
  h6: 14,
  subHead: 14,
  description: 16,
  body: 14
};

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  superBold: 900
};
